import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class OperationService {

  constructor(private http: HttpClient) { }

  getAllOperations(): Observable<any> {
    return this.http.get(mainUrl + 'param-operations')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createOperation(form): Observable<any> {
    return this.http.post(mainUrl + 'param-operation', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getOperationById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-operation/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateOperation(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-operation/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteOperation(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-operation/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}